export const Fonts = {
    light: 'Aestetico-Light',
    regular: 'Aestetico-Regular',
    semiBold: 'Aestetico-SemiBold'
}